import { render, staticRenderFns } from "./LogoutOrContinueModal.vue?vue&type=template&id=0b5248c2&scoped=true&"
import script from "./LogoutOrContinueModal.vue?vue&type=script&lang=js&"
export * from "./LogoutOrContinueModal.vue?vue&type=script&lang=js&"
import style0 from "./LogoutOrContinueModal.vue?vue&type=style&index=0&id=0b5248c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5248c2",
  null
  
)

export default component.exports